import React from 'react';
import AttachmentThumbnail from "../blocks/thumbnail/thumbnail";
// @ts-ignore
import AttachmentThumbnailUpload from "../blocks/thumbnail/thumbnail-upload";
// @ts-ignore
import UI5LoadingCircle from "../../../loading/loading-circle/loading-circle";
import Attachment from "../../../../model2/attachment/attachment";
import AttachmentButtonRemove from "../blocks/buttons/remove";

// const debug = "AttachmentViewUploadWithPreview"
const debug = false

type Props = {
    attachment      : Attachment
    onRemove?       : callback
    onAddToMessage? : callback
}

export default class AttachmentViewUploadWithPreview extends React.Component<Props>{

    constructor(props: Props) {
        super(props);

    }

    componentDidMount() {
        gd.bus.subscribe(this.props.attachment.fileId+'-progress', this, this.onUploadProgress);
        gd.bus.subscribe(this.props.attachment.fileId+'-generating-thumbnail', this, this.onUploadProgress);
        gd.bus.subscribe(this.props.attachment.fileId+'-upload-done', this, this.onUploadProgress);
    }

    componentWillUnmount() {
        gd.bus.unsubscribe(this)
    }

    onUploadProgress() {
        this.forceUpdate()
    }

    onRemoveClick = (e: React.SyntheticEvent) => {

        e.stopPropagation()

        if (this.props.onRemove) {
            this.props.onRemove(this.props.attachment)
        }
    }

    onAddToMessageClick = () => {
        if (this.props.onAddToMessage) this.props.onAddToMessage(this.props.attachment)
    }

    render() {
        debug && console.log(debug, "render()", this.props)

        const {attachment} = this.props

        let label;
        let preview;
        let canAddToMessage: any = false // boolean | callback

        switch (attachment.dropzoneFile.status) {

            case "added":
                label = "Preparing for upload..."
                preview = (
                    <div className="preview">
                        <AttachmentThumbnailUpload attachment={attachment} />
                        <div className="loading">
                            <UI5LoadingCircle value={0} size={40} />
                        </div>
                    </div>
                )
                break;

            case "uploading":
                const progress = Math.ceil(this.props.attachment.dropzoneFile.upload.progress)
                label = "Uploading... "+progress+"%"
                preview = (
                    <div className="preview">
                        <AttachmentThumbnailUpload attachment={attachment} />
                        <div className="loading">
                            <UI5LoadingCircle value={progress} size={40} />
                        </div>
                    </div>
                )
                break;

            case "generating-thumbnail":
                label = "Creating thumbnail..."
                preview = (
                    <div className="preview">
                        <AttachmentThumbnailUpload attachment={attachment} />
                        <div className="loading">
                            <UI5LoadingCircle value={100} size={40} />
                        </div>
                    </div>
                )
                break;

            case "success":
            default:
                preview = (
                    <div className="preview">
                        <AttachmentThumbnail attachment={attachment} />
                    </div>
                )
                label = this.props.attachment.name

                canAddToMessage = !attachment.inMessageRTF && this.props.onAddToMessage
                break;
        }

        return (
            <div className="ui5-attachment-with-preview">

                {preview}

                <div className="description">
                    <div className="ui5-txt-less-important-tiny w-100-percent t-a-center">{label}</div>
                </div>

                <div className="overlay-details">

                    {!canAddToMessage && <div className="file-name ui5-txt-less-important-small m-l-10 m-t-15">
                        {attachment.name}
                    </div>}
                    {!canAddToMessage && <div className="file-size ui5-txt-not-important-tiny m-l-10 ">
                        {attachment.fileSizeFormatted}
                    </div>}

                    {canAddToMessage &&
                        <div className="ui5-link-tiny m-t-50 w-100-percent t-a-center"
                             onClick={this.onAddToMessageClick}>
                            Insert in message
                        </div>}

                    <div className="attachment-preview-actions">
                        <div className="flex-row-center-center h-36">
                            <AttachmentButtonRemove onClick={this.onRemoveClick}/>
                        </div>

                        {/*<div className="attachment-buttons-block">*/}
                        {/*    */}
                        {/*</div>*/}
                    </div>

                </div>
            </div>
        )
    }
}
